
function HtmlEditor(settingsObject1, settingsObject2, settingsObjectN) {

    // public methods for statically-created form fields
    /**
     * add an HTML form element to the list of fields handled.  "static" means that the element itself will not be added or removed by JavaScript DOM operations
     */
    this.addStaticField = function(fieldName) {
        this._staticFieldNames[this._staticFieldNames.length] = fieldName;
    };
    // public methods for dynamically-created form fields (e.g. with dynamic.setDivIdContent())
    /**
     * will attach tinyMCE to the form field specified, then (if specified and present) un-hide the wrapper div
     *
     * @param fieldName (required) name of the form field name
     * @param fieldSettings (optional) field settings object
     *        sample fieldSettings object: {
     *            behavior_content_prompt_enabled : true,                  // (optional) enable focus/blur event handling to hide/show content_prompt for this field
     *            content_prompt                  : 'Enter comments here', // (required if behavior_content_prompt_enabled is true) editor content to show when field is empty and editor does not have focus
     *            wrapper_div_prefix              : 'htmlEditor'           // (optional) will be appended with form field name. HtmlEditor adds/removes css class 'hideIt' on removeControl/addControl
     *        }
     *
     */
    this.addControl = function(fieldName, fieldSettings) {
        var fieldIndex = this._getFieldIndex(fieldName);
        if (fieldIndex == -1) {
            this._addField(fieldName, fieldSettings);
            if (isObject(fieldSettings) && fieldSettings.behavior_content_prompt_enabled === true && fieldSettings.content_prompt) {
                var that = this;
                this.settings['event_callback_focus_'+fieldName] = function(editor, event){that._onFocus(editor, event);};
                this.settings['event_callback_blur_' +fieldName] = function(editor, event){that._onBlur(editor, event);};
            }
        }
        tinyMCE.settings = this.settings;
        tinyMCE.execCommand('mceAddControl', false, fieldName);
        this._unhide(fieldName);
    };
    /**
     * will (if specified and present) hide the wrapper div, then un-attach tinyMCE from the form field specified.
     * It is imperative that you call this method before dynamically removing the underlying form field from the html document, so tinyMCE's iframe gets removed as well.
     *
     * @param fieldName (required) name of the form field name
     */
    this.removeControl = function(fieldName) {
        var fieldIndex = this._getFieldIndex(fieldName);
        if (fieldIndex > -1) {
            this._hide(fieldName);
            this._removeField(fieldName);
            tinyMCE.execCommand('mceRemoveControl', false, fieldName);
            var fieldSettings = this._fieldSettings[fieldIndex];
            if (isObject(fieldSettings) && fieldSettings.behavior_content_prompt_enabled === true && fieldSettings.content_prompt) {
                delete this.settings['event_callback_focus'+fieldName];
                delete this.settings['event_callback_blur' +fieldName];
            }
        }
    };
    /**
     * returns the tinyMCE.Editor instance associated with the specified form field
     *
     * @param fieldName (required) name of the form field name
     */
    this.getEditor = function(fieldName) {
        return tinyMCE.get(fieldName);
    };
    /**
     * returns the html contents of the tinyMCE.Editor instance associated with the specified form field
     *
     * @param fieldName (required) name of the form field name
     */
    this.getContent = function(fieldName) {
        return this.getEditor(fieldName).getContent();
    };
    /**
     * triggers tinyMCE to write the contents of all Editor instances to the underlying form fields.
     * Use this in conjunction with ajax saves of form elements, where there is no form submit event that would otherwise trigger this save to happen.
     * This method will also check to see if field has settings, and if behavior_content_prompt_enabled is true, and the contents of the editor match the content_prompt,
     * the form field value will be cleared out.
     *
     * @param fieldName (required) name of the form field name
     */
    this.updateFormFields = function() {
        tinyMCE.triggerSave();
        for (var i = 0, ni = this._fieldNames.length; i < ni; i++) {
            var fieldName = this._fieldNames[i];
            var fieldSettings = this._fieldSettings[i];
            if (isObject(fieldSettings)
                    && fieldSettings.behavior_content_prompt_enabled === true
                    && fieldSettings.content_prompt
                    && getFormItemValue(fieldName) == fieldSettings.content_prompt) {
                resetFormItemValue(fieldName);
            }
        }
    };

    // private methods
    this._initializeStaticFields = function() {
        for (var i = 0, ni = this._staticFieldNames.length; i < ni; i++) {
            var fieldName = this._staticFieldNames[i];
            this.addControl(fieldName);
        }
    };
    this._addField = function(fieldName, fieldSettings) {
        var fieldIndex = this._getFieldIndex(fieldName);
        if (fieldIndex == -1) {
            fieldIndex = this._fieldNames.length;
            this._fieldNames   [fieldIndex] = fieldName;
            this._fieldSettings[fieldIndex] = fieldSettings;
        }
    };
    this._removeField = function(fieldName) {
        var fieldIndex = this._getFieldIndex(fieldName);
        if (fieldIndex > -1) {
            this._fieldNames.splice(fieldIndex, 1);
            this._fieldSettings.splice(fieldIndex, 1);
        }
    };
    this._getFieldIndex = function(fieldName) {
        for (var i = 0, ni = this._fieldNames.length; i < ni; i++) {
            var searchFieldName = this._fieldNames[i];
            if (searchFieldName == fieldName) {
                return i;
            }
        }
        return -1;
    };
    this._onFocus = function(editor, event) {
        var fieldIndex = this._getFieldIndex(editor.id);
        if (fieldIndex > -1) {
            var fieldSettings = this._fieldSettings[fieldIndex];
            if (isObject(fieldSettings) && fieldSettings.content_prompt) {
                var content = editor.getContent();
                if (content == fieldSettings.content_prompt) {
                    editor.setContent('');
                }
            }
        }
    };
    this._onBlur = function(editor, event) {
        var fieldIndex = this._getFieldIndex(editor.id);
        if (fieldIndex > -1) {
            var fieldSettings = this._fieldSettings[fieldIndex];
            if (isObject(fieldSettings) && fieldSettings.content_prompt) {
                var content = editor.getContent();
                if (content == '') {
                    editor.setContent(fieldSettings.content_prompt);
                }
            }
        }
    };
    this._hide = function(fieldName) {
        var fieldIndex = this._getFieldIndex(fieldName);
        if (fieldIndex > -1) {
            var fieldSettings = this._fieldSettings[fieldIndex];
            if (isObject(fieldSettings) && fieldSettings.wrapper_div_prefix) {
                $('#'+fieldSettings.wrapper_div_prefix+fieldName).addClass('hideIt');
            }
        }
    };
    this._unhide = function(fieldName) {
        var fieldIndex = this._getFieldIndex(fieldName);
        if (fieldIndex > -1) {
            var fieldSettings = this._fieldSettings[fieldIndex];
            if (isObject(fieldSettings) && fieldSettings.wrapper_div_prefix) {
                $('#'+fieldSettings.wrapper_div_prefix+fieldName).removeClass('hideIt');
            }
        }
    };

    // private properties
    this._staticFieldNames = new Array();
    this._fieldNames = new Array();
    this._fieldSettings = new Array();

    // startup
    var settings = {};
    for (var a = 0, na = arguments.length; a < na; a++) {
        var settingsObject = arguments[a];
        for (var i in settingsObject) {
            settings[i] = settingsObject[i];
        }
    }
	this.settings = settings;
	var that = this;
    $(window).load(function() {that._initializeStaticFields();});
}
